<template>
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Error Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      
    </section>

    <section id="dashboard_data" v-if="salesData">
      <DataTable2 
        
        :raw_data="salesData"
        :name="'dash_sales_detail'"
        :columns_from_parent="[
          {
            label: 'Part',
            field: 'part_number',
            type: 'text',
          },
          {
            label: 'Description',
            field: 'description',
            type: 'text',
          },
          {
            label: 'Invoice',
            field: 'invoice',
            type: 'text',
          },
          {
            label: 'Margin',
            field: 'margin',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00%')},
          },
          {
            label: 'Company PO',
            field: 'company_po_number',
            type: 'text',
          },
          {
            label: 'Profit',
            field: 'profit',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Unit Cost',
            field: 'unit_cost',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Unit Price',
            field: 'unit_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Total Cost',
            field: 'total_cost',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Total Price',
            field: 'total_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Bill Name',
            field: 'bill_name',
            type: 'text',
          },
          {
            label: 'Vendor',
            field: 'vendor_name',
            type: 'text',
          },
          {
            label: 'Dept Name',
            field: 'dept_name',
            type: 'text',
          },
          {
            label: 'Orig PO',
            field: 'original_po_number',
            type: 'text',
          },
          {
            label: 'Qty Ship',
            field: 'qty_ship',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
          },
          {
            label: 'Reference',
            field: 'reference',
            type: 'text',
          },
          {
            label: 'Invoice Date',
            field: 'invoice_date',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
          {
            label: 'Post Date',
            field: 'post_date',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
          {
            label: 'Time Created',
            field: 'time_created',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
        ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [salesData.data, 'ErrorsDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>

    
  </div>
</template>

<style scoped>
  .title_div{
    margin-top: 1.5em;
  }

  .site{
    font-size: 2em;
  }

</style>

<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import moment from 'moment';
import {
  DASHBOARD_ERRORS,
  DASHBOARD_MARGIN_ADD,
  DASHBOARD_MARGIN_REMOVE
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardErrors',
  components: {
    DataTable2,
    HeroContainer,
  },
  computed:{
    queryData(){
      let raw_query = {...this.queryDataRaw} 
      return raw_query
    },
    salesData(){
      if (Object.prototype.hasOwnProperty.call(this.queryData, 'sales')){
        return this.queryData.sales
      }
      return {}
    },
  },
  data: function(){
    return {
      numeral: require('numeral'),
      part_number: '',
      price_difference_low: '',
      price_difference_high: '',
      percent_difference_low: '',
      percent_difference_high: '',
      date_range: 'week',
      range: [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ],
      queryDataRaw: {},
    };
  },
  mounted: function(){
    this.ajax_get_dashboard()
  },
  methods: {
    reset(){
      this.part_number = ''
      this.price_difference_low = ''
      this.price_difference_high = ''
      this.percent_difference_low = ''
      this.percent_difference_high = ''
      this.date_range=  'week'
      this.range = [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ]
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_records(){
      this.ajax_get_dashboard(this.filter_customer, this.filter_user)
    },
    ajax_get_dashboard(){
      let url = DASHBOARD_ERRORS
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, dashboard){
        this_vue.queryDataRaw = dashboard
      }
      fetch(url, {
        method:'GET',
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.dashboard)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_dashboard_margin_remove(){
      let url = DASHBOARD_MARGIN_REMOVE
      this.set_searching(true)
      let rows = this.$refs['margin_dash_table'].selectedRows;
      let part_numbers = []
      for(let row of rows){
        part_numbers.push(row.part_number)
      }
      let this_vue = this
      function set_parts(this_vue, part_numbers){
        for(let row of this_vue.queryData){
          if (part_numbers.includes(row.part_number)){
            row.removed = true
          }
        }
        
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({part_numbers: part_numbers, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_parts(this_vue, res.part_numbers)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_dashboard_margin_add(){
      let url = DASHBOARD_MARGIN_ADD
      this.set_searching(true)
      let rows = this.$refs['margin_dash_removed_table'].selectedRows;
      let part_numbers = []
      for(let row of rows){
        part_numbers.push(row.part_number)
      }
      let this_vue = this
      function set_parts(this_vue, part_numbers){
        for(let row of this_vue.queryData){
          if (part_numbers.includes(row.part_number)){
            row.removed = false
          }
        }
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({part_numbers: part_numbers, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_parts(this_vue, res.part_numbers)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
